import { createSlice } from "@reduxjs/toolkit";

const parametrosSlice = createSlice({
  name: "parametros",
  initialState: {
    currentParametros: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    parametrosStart: (state) => {
      state.isFetching = true;
    },
    parametrosSuccess: (state, action) => {
      state.isFetching = false;
      state.currentParametros = action.payload;
    },
    parametrosFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    createParametroStart: (state) => {
        state.isFetching = true;
    },
    createParametroSuccess: (state, action) => {
        state.isFetching = false;
        state.currentParametros = action.payload
        state.errorCreate = false;
    },
    createParametroFailure: (state) => {
        state.isFetching = false;
        state.errorCreate = true;
    },
    logoutInfoparametros: (state) => {
      state.currentParametros = null;
      state.isFetching = false;
      state.error = false;
      state.errorCreate = false;
    },
  },
});

export const {
  parametrosStart,
  parametrosSuccess,
  parametrosFailure,
  createParametroStart, 
  createParametroSuccess, 
  createParametroFailure,
  logoutInfoparametros
} = parametrosSlice.actions;
export default parametrosSlice.reducer;
